import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  basicTitle: {
    id: 'course-authoring.schedule.basic.title',
    defaultMessage: 'Basic information',
  },
  basicDescription: {
    id: 'course-authoring.schedule.basic.description',
    defaultMessage: 'The nuts and bolts of this course',
  },
  basicEmailIcon: {
    id: 'course-authoring.schedule.basic.email-icon',
    defaultMessage: 'Invite your students email icon',
  },
  courseOrganization: {
    id: 'course-authoring.schedule.basic.organization',
    defaultMessage: 'Organization',
  },
  courseNumber: {
    id: 'course-authoring.schedule.basic.course-number',
    defaultMessage: 'Course number',
  },
  courseRun: {
    id: 'course-authoring.schedule.basic.course-run',
    defaultMessage: 'Course run',
  },
  basicBannerTitle: {
    id: 'course-authoring.schedule.basic.banner.title',
    defaultMessage: 'Promoting your course with edX',
  },
  basicBannerText: {
    id: 'course-authoring.schedule.basic.banner.text',
    defaultMessage: 'Your course summary page will not be viewable until your course has been announced. To provide content for the page and preview it, follow the instructions provided by your Program Manager. Please note that changes here may take up to a business day to appear on your course summary page.',
  },
  basicPromotionButton: {
    id: 'course-authoring.schedule.basic.promotion.button',
    defaultMessage: 'Invite your students',
  },
});

export default messages;
